export const ROUTE_HOME = 'https://www.poltronesofa.com/fr-FR/Index';
export const ROUTE_CHOOSE_STORE = 'choose-store';
export const ROUTE_DATE_AND_HOUR = 'date-and-hour';
export const ROUTE_CONFIRMATION = 'confirmation';
export const ROUTE_CONTACT_INFORMATION = 'contact-information';
export const ROUTE_VERIFICATION = 'verification';
export const ROUTE_APPOINTMENT_DETAILS = 'appointment/:bookingUuid';
